import Vue from 'vue';
import VueVirtualScroller from 'vue-virtual-scroller';
Vue.use(VueVirtualScroller);
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

import VirtualCollection from 'vue-virtual-collection';
Vue.use(VirtualCollection);
